import {RunStates} from './runStates'
import {AppConfig} from '@/appConfig'

export const BlankState = {
  validationResult: null,
  firstTimeInitialized: true,
  preSubmissionOptions: {
    nikudType: 'auto',
    chosenTextTypeName: AppConfig.TALMUD_GENRE.DEFAULT ? 'talmud' : 'rabbinic',
    skipLetters: false,
    skipAbbrevs: false,
    skipParens: false,
    skipBrackets: false,
    skipBraces: false,
    skipVoc: false,
    skipPartVoc: false,
    splitParens: false,
    dageshOnlyIfHeard: false,
    ketivMaleh: false,
    useQamatzQatan: false,
    keepSourceDagesh: false,
    mahPatachDagesh: false,
    showApiNonConfident: false, // considered "preSubmission" b/c we're not allowing CHANGING it after submission
    dropboxIdForSpecialOptions: null // options from loadedFileSettings are stored as 1 or 0,
  },                                 // and revert to the default when that file's "unloaded"
  nakdanApiState: RunStates.NOT_RUN,
  genreClassifyApiState: RunStates.NOT_RUN,
  originalDocument: {
    id: -0.1,
    text: '',
    source: {
      fileBase64Contents: null,
      type: null,
      runArray: [],
      wordToRunAndPosMap: []        
    },
    identifiedGenre: null
  },
  forNakdanApiCall: {
    text: '', // note that both initial states are "falsy" 
    jsonData: null, // because no more than ONE can be "truthy" at a time
  },
  nakdanApiResponse: [],
  allWorkingNikud: {
    id: -0.01,
    wordsArray: [],
    lastWordId: -1
  },
  wordIdToIndexMap: {},
  currentPositionData: {
    wordIndex: -1,
    letterIndex: -1
  },
  postSubmissionOptions: {
    showAims: true,
    nikudKeyboard: 'new',
    showNikudButtons: false,
    disableGoHomePrompt: false,
    disableBackToTextPrepPrompt: false,
    disableSwitchGenrePrompt: false,
    disableUploadDictionaryPrompt: false
  }
}

export const BlankUserData = null

export const BlankDictionary = {
  entryPresent: {},
  lettersMap: {},
  negativeEntryPresent: {},
  negativeLettersMap: {}
}

let statePartTypes = {
  'never-save': ['account', 'dropbox', 'validationResult'], // not really needed since they're not in BlankState
  'session-parts': ['firstTimeInitialized']
}
statePartTypes['document-parts'] = Object.keys(BlankState)
                                        .filter(k => !(Object.values(statePartTypes)
                                                             .some(arr => arr.includes(k)))) // i.e. all the rest
export const StatePartTypes = statePartTypes // note that b/c of DocumentManager, ONLY ONE key has 'document' in it
